module.exports = __webpack_public_path__ + "static/media/ss2.c305452e.jpg";